//Built-in libraries
import type { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';
//Custom components
import Table from '@/components/UI/Table';

//Services

import { InformationCircleIcon } from '@heroicons/react/24/outline';
//Assets and Miscellaneous
import Card from '@/components/UI/Card/index.tsx';

interface BreakdownByScopeProps {
  breakdownByScope: Array<{ scope: string; projects: number }>;
}

const BreakdownByScopeWidget = ({ breakdownByScope }: BreakdownByScopeProps) => {
  const [perPage, setPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, _setTotalPage] = useState<number>(1);

  const nextPageHandler = () => {
    setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
  };

  const previousPageHandler = () => {
    setPage((prevState) => (prevState > 1 ? page - 1 : 1));
  };
  const tableColumns: ColumnDef<any>[] = [
    {
      id: 'scope',
      header: () => <div className='font-bold'>Scope</div>,
      accessorKey: 'scope',
      cell: (props) => {
        const { getValue } = props;
        const value = getValue() as string;
        return <span className='capitalize'>{value}</span>;
      },
    },
    {
      id: 'projects',
      header: () => <div className='font-bold'>Projects</div>,
      accessorKey: 'projects',
      cell: (props) => {
        const { getValue } = props;
        const value = getValue() as number;
        return <span>{value}</span>;
      },
    },
  ];

  const tablePagination = {
    page: page,
    pageSize: perPage,
    pageCount: totalPage,
    currentPage: page,
    setPageSize: (v: number) => setPerPage(v),
    nextPage: nextPageHandler,
    previousPage: previousPageHandler,
  };

  return (
    <Card title='Breakdown By Scope'>
      {breakdownByScope.length > 0 && (
        <div className='h-full w-full'>
          <div className='h-96 border rounded-b-md w-full'>
            <Table cols={tableColumns} tableData={breakdownByScope} pagination={tablePagination} height='h-5/6' />
          </div>
        </div>
      )}
      {breakdownByScope.length === 0 && (
        <div className='p-2 mt-2 flex flex-col items-center justify-center gap-2 h-screen/2'>
          <span>
            <InformationCircleIcon className='h-8 w-8 text-primaryColor-normal' />
          </span>
          <p>There are no scopes</p>
        </div>
      )}
    </Card>
  );
};

export default BreakdownByScopeWidget;
